import { Component, OnInit, OnDestroy } from '@angular/core';
import { MemberService } from "../services/member.service";
import { SortableComponent } from '../../core/sortable/sortable.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ch-verification-codes',
  templateUrl: './verification-codes.component.html',
  styleUrls: ['./verification-codes.component.css'],
})
export class VerificationCodesComponent implements OnInit, OnDestroy {
  public items = [];
  private filterFields: string[] = ['search', 'pageSize'];

  public loading: boolean;

  constructor(
    private memberService: MemberService,
    private titleService: Title,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(`Verification Codes | CODE Hospitality CMS`);
    this.loadItems();
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private loadItems() {
    this.loading = true;
    this.memberService.getVerificationCodes().subscribe(result => {
      this.items = result.json();
      this.loading = false;
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/verification-codes/verification-codes.component.ts